import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface ICustomerFilterStrings extends LocalizedStringsMethods {
    lsNameTxt: string;
    lsContactFirstNameTxt: string;    
    lsContactLastNameTxt: string;
    lsContactPhoneTxt: string;
    lsContactEmailTxt: string;     
}

let strings: ICustomerFilterStrings;
export default strings = new LocalizedStrings({
    en: {
        lsNameTxt: 'Name',
        lsContactFirstNameTxt: 'Contact First Name',    
        lsContactLastNameTxt: 'Contact Last Name',
        lsContactPhoneTxt: 'Contact Phone',
        lsContactEmailTxt: 'Contact Email',
    },
    es: {
        lsNameTxt: 'Nombre',
        lsContactFirstNameTxt: 'Nombre de pila de contacto',    
        lsContactLastNameTxt: 'Apellido de contacto',
        lsContactPhoneTxt: 'teléfono de contacto',
        lsContactEmailTxt: 'Email de contacto', 
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/customer/string.customer.filter.tsx